<template>
  <svg width="46" height="20" viewBox="0 0 46 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.6" d="M0 20C0 8.95431 8.95431 0 20 0H26C37.0457 0 46 8.95431 46 20H0Z" fill="url(#paint0_linear_963_8814)"/>
    <defs>
      <linearGradient id="paint0_linear_963_8814" x1="23" y1="0" x2="23" y2="18" gradientUnits="userSpaceOnUse">
        <stop stop-color="#E76C00"/>
        <stop offset="1" stop-color="white" stop-opacity="0"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name:'SelectBack3',
}
</script>